module.exports = __webpack_public_path__ + "img/nlogo.247ab561.png";